/** Shared site URL constants (safe for Node scripts + browser). */
export const SITE_ORIGIN = 'https://dilinh.com';

/** Static marketing routes included in the sitemap (and largely prerendered). */
export const STATIC_SITEMAP_PATHS = [
  '/',
  '/practices',
  '/practices/corporate',
  '/practices/licensing',
  '/practices/labour',
  '/practices/privacy',
  '/practices/realestate',
  '/practices/disputes',
  '/team',
  '/toolkits',
  '/updates',
  '/contact',
];

export function absoluteUrl(pathname) {
  if (!pathname || pathname === '/') return `${SITE_ORIGIN}/`;
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${SITE_ORIGIN}${path}`;
}
